// extracted by mini-css-extract-plugin
module.exports = {"selectionblock__wrapper":"SelectionBlock_selectionblock__wrapper__Rd2Aa","selectionblock__remove-button":"SelectionBlock_selectionblock__remove-button__QVMUR"};